import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { YoutubePlayerComponent } from './youtube-player.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule
  ],
  exports: [YoutubePlayerComponent],
  declarations: [YoutubePlayerComponent]
})
export class YoutubePlayerModule { }


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/youtube-player/youtube-player.module.ts